/**
 * Chat Rooms Routes - AI Focus
 * Rotas para o módulo de Chat Rooms (comunicação interna)
 */

import { frontendURL } from '../helper/URLHelper';

// Importar componentes - Chat
const ChatRoomLayout = () =>
  import('../components/ChatRooms/ChatRoomLayout.vue');
const ChatRoomView = () => import('../components/ChatRooms/ChatRoomView.vue');
const ChatRoomEmptyState = () =>
  import('../components/ChatRooms/ChatRoomEmptyState.vue');

// Importar componentes - Settings
const SettingsIndex = () =>
  import('../components/ChatRooms/settings/Index.vue');
const CreateRoom = () =>
  import('../components/ChatRooms/settings/CreateRoom.vue');
const EditRoom = () => import('../components/ChatRooms/settings/EditRoom.vue');
const AddMembers = () =>
  import('../components/ChatRooms/settings/AddMembers.vue');
const EditMembers = () =>
  import('../components/ChatRooms/settings/EditMembers.vue');
const FinishSetup = () =>
  import('../components/ChatRooms/settings/FinishSetup.vue');

// Permissões necessárias
const PERMISSIONS = [
  'administrator',
  'agent',
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

const ADMIN_PERMISSIONS = ['administrator'];

export default {
  routes: [
    // Main chat routes
    {
      path: frontendURL('accounts/:accountId/chat_rooms'),
      component: ChatRoomLayout,
      meta: {
        permissions: PERMISSIONS,
        featureFlag: 'chat_rooms',
      },
      children: [
        {
          path: '',
          name: 'chat_rooms_index',
          component: ChatRoomEmptyState,
        },
        {
          path: ':roomId',
          name: 'chat_rooms',
          component: ChatRoomView,
          props: route => ({
            roomId: Number(route.params.roomId),
          }),
        },
      ],
    },
  ],
  // Settings routes - these will be merged into settings section
  settingsRoutes: [
    {
      path: frontendURL('accounts/:accountId/settings/chat_rooms'),
      meta: {
        permissions: ADMIN_PERMISSIONS,
        featureFlag: 'chat_rooms',
      },
      children: [
        {
          path: '',
          name: 'settings_chat_rooms_list',
          component: SettingsIndex,
          meta: {
            permissions: ADMIN_PERMISSIONS,
            featureFlag: 'chat_rooms',
          },
        },
        {
          path: 'new',
          name: 'settings_chat_rooms_new',
          component: CreateRoom,
          meta: {
            permissions: ADMIN_PERMISSIONS,
            featureFlag: 'chat_rooms',
          },
        },
        {
          path: ':roomId/edit',
          name: 'settings_chat_rooms_edit',
          component: EditRoom,
          props: route => ({ roomId: Number(route.params.roomId) }),
          meta: {
            permissions: ADMIN_PERMISSIONS,
            featureFlag: 'chat_rooms',
          },
        },
        {
          path: ':roomId/members',
          name: 'settings_chat_rooms_add_members',
          component: AddMembers,
          props: route => ({ roomId: Number(route.params.roomId) }),
          meta: {
            permissions: ADMIN_PERMISSIONS,
            featureFlag: 'chat_rooms',
          },
        },
        {
          path: ':roomId/members/edit',
          name: 'settings_chat_rooms_edit_members',
          component: EditMembers,
          props: route => ({ roomId: Number(route.params.roomId) }),
          meta: {
            permissions: ADMIN_PERMISSIONS,
            featureFlag: 'chat_rooms',
          },
        },
        {
          path: ':roomId/finish',
          name: 'settings_chat_rooms_finish',
          component: FinishSetup,
          props: route => ({ roomId: Number(route.params.roomId) }),
          meta: {
            permissions: ADMIN_PERMISSIONS,
            featureFlag: 'chat_rooms',
          },
        },
      ],
    },
  ],
};
